import React, { FC } from 'react';
import cls from 'classnames';
import { format } from 'date-fns';
import { Image, Size } from '@stashinvest/react-assets';
import { IconVariant, AvatarProps } from './Avatar.types';
import { ColorClassnames } from '../../../../../tailwind/src/theme';

const getVariantClass = ({ type }: AvatarProps['variant']) => {
	if (type === 'icon') {
		return 'variant-icon';
	} else if (type === 'image') {
		return 'variant-image';
	} else if (type === 'date') {
		return 'variant-date';
	}
};
type Sizes = IconVariant['size'];

const Avatar: FC<AvatarProps> = (props) => {
	const {
		className,
		shape = 'square',
		backgroundType = 'fill',
		variant,
		isEnabled = true,
	} = props;

	return (
		<div
			className={cls(
				'sds-avatar',
				className,
				shape,
				backgroundType,
				getVariantClass(variant),
				{ 'is-disabled': !isEnabled }
			)}
		>
			{(() => {
				if (variant.type === 'icon') {
					const { variant: iconVariant = 'neutral', size = 'medium', Icon } = variant;
					const variantToTokenMap: { [key in typeof iconVariant]: ColorClassnames } = {
						neutral: 'text-onSurface',
						brand: 'text-onPrimaryContainer',
						error: 'text-onErrorContainer',
						success: 'text-onSuccessContainer',
						warning: 'text-onWarningContainer',
						inverse: 'text-inverseOnSurface',
					};

					const IconSizeMap: { [key in Sizes]: { className: string; iconSize: Size } } = {
						small: { className: 'size-small', iconSize: 'XS' },
						medium: { className: 'size-medium', iconSize: 'small' },
						large: { className: 'size-large', iconSize: 'medium' },
					};
					return (
						<div
							className={cls(iconVariant, IconSizeMap[size].className, {
								['opacity-opacityContent']: !isEnabled,
							})}
						>
							<Icon
								size={IconSizeMap[size].iconSize}
								color={isEnabled ? variantToTokenMap[iconVariant] : 'text-onSurface'}
							/>
						</div>
					);
				}
				if (variant.type === 'image') {
					return (
						<Image
							className={cls({
								'opacity-opacityContent': !isEnabled,
							})}
							imageToken={variant.imageToken}
							altText={variant.altText}
							size={'medium'}
						/>
					);
				}
				if (variant.type === 'date') {
					const dayOfWeek = format(variant.date, 'eee');
					const dayOfMonth = format(variant.date, 'd');
					return (
						<>
							<p className={'top'}>{dayOfWeek}</p>
							<p className={'bottom'}>{dayOfMonth}</p>
						</>
					);
				}
			})()}
		</div>
	);
};

Avatar.displayName = 'Avatar';

export default Avatar;
